// Stub do keycloak-js usado em modo dev (bypass do login real).
// Ativado pelo auth.module quando NODE_ENV=development e o flag de
// "usar Keycloak real" não está setado.

const DEV_EMAIL = "DEV_B42@b42.com.br";
const DEV_TOKEN = "dev-bypass";
const DEV_REFRESH_TOKEN = "dev-bypass-refresh";

const ROLES = [
  "feature:authenticate",
  "superuser",
  "catalogos.read",
  "cursos.read",
  "cursos.manage",
  "disciplinas.read",
  "disciplinas.manage",
  "unidades.read",
  "unidades.manage",
  "autores.read",
  "autores.manage",
  "videos.read",
  "videos.manage",
  "alternativas.read",
  "alternativas.manage",
  "fornecedores.read",
  "fornecedores.manage",
  "titulacoes.read",
  "titulacoes.manage",
  "tags.read",
  "tags.manage",
  "documentos.read",
  "documentos.manage",
  "impersonate",
  "eadstock-client",
  "gael-lxp-estudante"
];

const RESOURCE_ACCESS = {
  gaelwebapp: { roles: ROLES },
  eadstockwebapp: { roles: ROLES },
  eadstock2webapp: { roles: ROLES },
  stagegaelwebapp: { roles: ROLES },
  stageeadstockwebapp: { roles: ROLES },
  stageeadstock2webapp: { roles: ROLES }
};

export function createKeycloakStub() {
  const idTokenParsed = {
    name: "Dev B42",
    email: DEV_EMAIL,
    given_name: "Dev",
    family_name: "B42",
    groups: ["/gael/b42", "/eadstock-b42", "/eadstock/b42", "/go/b42"],
    // DEV: planos do token (igual a um usuário de cliente real). Era [] (B42 =
    // todos os planos). Setado pra validar local que o card do dashboard envia
    // planosId igual ao catálogo. Reverter para [] se quiser B42 sem filtro.
    //planos: [2, 3, 4, 5, 6]
    planos: []
  };

  return {
    authenticated: true,
    token: DEV_TOKEN,
    refreshToken: DEV_REFRESH_TOKEN,
    sessionId: "dev-session",
    idTokenParsed,
    tokenParsed: idTokenParsed,
    resourceAccess: RESOURCE_ACCESS,
    hasResourceRole(role) {
      return ROLES.includes(role);
    },
    updateToken() {
      return Promise.resolve(false);
    },
    login() {},
    logout() {
      // Em dev nada acontece: o "logout" não tem para onde redirecionar.
      // Limpa o flag pra que um reload comece do zero, se quiser.
      try {
        localStorage.removeItem("keycloakReal");
      } catch (e) {}
      window.location.reload();
    }
  };
}

export function isDevBypassActive(store) {
  try {
    return store.getters["auth/keycloak"].token === DEV_TOKEN;
  } catch (e) {
    return false;
  }
}

export function isKeycloakBypassEnabled() {
  if (process.env.NODE_ENV !== "development") {
    return false;
  }
  if (process.env.VUE_APP_KEYCLOAK_REAL === "true") {
    return false;
  }
  try {
    if (localStorage.getItem("keycloakReal") === "1") {
      return false;
    }
  } catch (e) {}
  return true;
}
